const telemetryFieldsInfo = {
  // Battery, Consumption, grid, solar
  Pri: { step: '0.01', unit: '', mode: 'AVG' }, // Prioridad
  BtTy: { step: '0.01', unit: '', mode: 'AVG' }, // Tipo de batería
  SysM: { step: '0.01', unit: '', mode: 'AVG' }, // Modo de sistema
  DerM: { step: '0.01', unit: '', mode: 'AVG' }, // Modo de reducción
  Time: { step: '0.01', unit: 'h' }, // Tiempo de trabajo total
  // Temp: { step: 1, unit: '°C' }, // Temperatura SPH
  // TIPM: { step: 1, unit: '°C' }, // Temperatura IPM
  // TemB: { step: 1, unit: '°C' }, // Aumento temperatura
  // Solar, Grid, Battery
  SPHS: { step: '0.01', unit: '%', mode: 'AVG' }, // Estado SPH
  // Battery, Solar
  SOH: { step: 1, unit: '%', mode: 'AVG' }, // Estado vida útil
  // Battery
  BtV: { step: 1, unit: 'V', mode: 'MAX' }, // Voltaje de batería
  SOC: { step: 1, unit: '%', mode: 'MAX' }, // Estado de carga
  BtT: { step: 1, unit: '°C', mode: 'MAX' }, // Temperatura de batería
  BtS: { step: 1, unit: '', mode: 'AVG' }, // Estado batería BMS
  SOCB: { step: 1, unit: '%', mode: 'MAX' }, // Estado de carga BMS
  BtVB: { step: 0.1, unit: 'V', mode: 'MAX' }, // Voltaje de batería BMS
  BtCB: { step: 1, unit: 'A', mode: 'MAX' }, // Corriente batería BMS
  BtTB: { step: 1, unit: '°C', mode: 'MAX' }, // Temperatura batería BMS
  BtMC: { step: 1, unit: 'A', mode: 'MAX' }, // Máxima corriente de carga y descarga
  BtCy: { step: 1, unit: '', mode: 'AVG' }, // Contador de ciclos
  DisED: { step: 1, unit: 'kWh', mode: 'MAX' }, // Energía descargada hoy
  DisET: { step: 1, unit: 'kWh', mode: 'MAX' }, // Energía descargada total
  ChED: { step: 1, unit: 'kWh', mode: 'MAX' }, // Energía cargada hoy
  ChET: { step: 1, unit: 'kWh', mode: 'MAX' }, // Energía cargada total
  ACCD: { step: 1, unit: 'kWh', mode: 'MAX' }, // Energía de red cargada hoy
  ACCT: { step: 1, unit: 'kWh', mode: 'MAX' }, // Energía de red cargada total
  DisP: { step: 0.001, unit: 'kW', mode: 'MAX' }, // Potencia de descarga
  ChrP: { step: 0.001, unit: 'kW', mode: 'MAX' }, // Potencia de carga
  // Consumption
  ELd: { step: 1, unit: 'kWh', mode: 'MAX' }, // Energía a la carga
  AConT: { step: 1, unit: 'kWh', mode: 'MAX' }, // Energía a la carga
  AConD: { step: 1, unit: 'kWh', mode: 'MAX' }, // Energía a la carga
  LConD: { step: 1, unit: 'kWh', mode: 'MAX' }, // Energía a la carga
  ESisT: { step: 1, unit: 'kWh', mode: 'MAX' }, // Energía a la carga
  ESisD: { step: 1, unit: 'kWh', mode: 'MAX' }, // Energía a la carga
  LConT: { step: 1, unit: 'kWh', mode: 'MAX' }, // Consumo total Carga
  PLdT: { step: 0.001, unit: 'kW', mode: 'MAX' }, // Potencia inversor
  PAuC: { step: 0.001, unit: 'kW', mode: 'MAX' }, // Potencia Autoconsumo
  // grid
  GpAV: { step: 1, unit: 'V', mode: 'AVG' }, // Voltaje fase A
  GpAC: { step: 1, unit: 'A', mode: 'MAX' }, // Corriente fase A
  GpAP: { step: 0.001, unit: 'kW', mode: 'MAX' }, // Potencia fase A
  GpBV: { step: 1, unit: 'V', mode: 'AVG' }, // Voltaje fase B
  GpBC: { step: 1, unit: 'A', mode: 'MAX' }, // Corriente fase B
  GpBP: { step: 0.001, unit: 'kW', mode: 'MAX' }, // Potencia fase B
  GpCV: { step: 1, unit: 'V', mode: 'AVG' }, // Voltaje fase C
  GpCC: { step: 1, unit: 'A', mode: 'MAX' }, // Corriente fase C
  GpCP: { step: 0.001, unit: 'kW', mode: 'MAX' }, // Potencia fase C
  EGD: { step: 1, unit: 'kWh', mode: 'MAX' }, // Energía de red hoy
  EGT: { step: 1, unit: 'kWh', mode: 'MAX' }, // Energía de red total
  EGL: { step: 1, unit: 'kWh', mode: 'MAX' }, // Energía a la carga
  ImED: { step: 1, unit: 'kWh', mode: 'MAX' }, // Energía importada hoy
  ImET: { step: 1, unit: 'kWh', mode: 'MAX' }, // Energía importada total
  ExED: { step: 1, unit: 'kWh', mode: 'MAX' }, // Energía exportada hoy
  ExET: { step: 1, unit: 'kWh', mode: 'MAX' }, // Energía exportada total
  GPw: { step: 0.001, unit: 'kW', mode: 'MAX' }, // Salida de potencia AC
  ImPT: { step: 0.001, unit: 'kW', mode: 'MAX' }, // Potencia importada total
  ExPT: { step: 0.001, unit: 'kW', mode: 'MAX' }, // Potencia exportada total
  GF: { step: 1, unit: 'Hz', mode: 'AVG' }, // Frecuencia de red
  PF: { step: 0.01, unit: '', mode: 'AVG' }, // Factor de potencia
  IPF: { step: 1, unit: '', mode: 'AVG' }, // Salida factor de potencia SPH
  ExLm: { step: 0.001, unit: 'kW', mode: 'MAX' }, // Limite de potencia aparente
  ROP: { step: 1, unit: '%', mode: 'MAX' }, // Porcentaje de potencia real
  OMP: { step: 0.001, unit: 'kW', mode: 'MAX' }, // Limite de potencia máxima
  ApP: { step: 0.001, unit: 'kW', mode: 'MAX' }, // Potencia aparente
  ReaP: { step: 0.001, unit: 'kW', mode: 'MAX' }, // Potencia reactiva real
  ReaN: { step: 0.001, unit: 'kW', mode: 'MAX' }, // Potencia reactiva nominal
  ReaG: { step: 0.001, unit: 'kW', mode: 'MAX' }, // Potencia reactiva generada
  PSis: { step: 0.001, unit: 'kW', mode: 'MAX' },
  PLoad: { step: 0.001, unit: 'kW', mode: 'MAX' },
  // Solar
  pv1: { step: 1, unit: 'V', mode: 'MAX' }, // Voltage panel 1
  pc1: { step: 1, unit: 'A', mode: 'MAX' }, // Current panel 1
  pw1: { step: 0.001, unit: 'kW', mode: 'MAX' }, // Power panel 1
  pv2: { step: 1, unit: 'V', mode: 'MAX' }, // Voltage panel 2
  pc2: { step: 1, unit: 'A', mode: 'MAX' }, // Current panel 2
  pw2: { step: 0.001, unit: 'kW', mode: 'MAX' }, // Power panel 2
  pv3: { step: 1, unit: 'V', mode: 'MAX' }, // Voltage panel 3
  pc3: { step: 1, unit: 'A', mode: 'MAX' }, // Current panel 3
  pw3: { step: 0.001, unit: 'kW', mode: 'MAX' }, // Power panel 3
  pED: { step: 1, unit: 'kWh', mode: 'MAX' }, // PV energy today
  pET: { step: 1, unit: 'kWh', mode: 'MAX' }, // PV energy total
  pPT: { step: 0.001, unit: 'kW', mode: 'MAX' }, // PV power total

};

export default telemetryFieldsInfo;
